import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "notion",
  "name": "Notion",
  "category": "integrations",
  "description": "Create and manage Notion pages and databases",
  "icon": "siNotion",
  "iconType": "simple-icon",
  "color": "gray",
  "version": "2.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Notion",
    "color": "#000000"
  },
  "credentials": [
    {
      "name": "notionApi",
      "required": true,
      "displayName": "Notion API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "notion",
    "notes",
    "database",
    "docs",
    "wiki"
  ],
  "comingSoon": true
};

export default definition;
